export default () => {
	if (window["asl_jQuery"] && asl_jQuery.views) {
		asl_jQuery.views.tags("test", function () {
			console.log(this);
			return "test";
		});
	}
	if (window["asl_jQuery"] && asl_jQuery.views) {
		//  svg wrapper
		asl_jQuery.views.tags("chairCount", function (_field) {
			var renderedHtml = "";
			var chairText = "";
			var separator = true;

			var level = parseInt(_field, 10);

			// mapping levels to text
			switch (level) {
				case 1:
					chairText = "up to 4 chairs";
					break;
				case 2:
					chairText = "5-11 chairs";
					break;
				case 3:
					chairText = "12-23 chairs";
					break;
				case 4:
					chairText = "24+ chairs";
					break;
				default:
					separator = false;
					chairText = ""; // Optional: Handle unexpected levels
			}

			// Adding separator if needed
			if (separator) {
				renderedHtml += `<span class="chair-count-separator"> | </span>`;
			}

			// Adding chair count text
			renderedHtml += `<span class="chair-count">${chairText}</span>`;

			return renderedHtml;
		});

		asl_jQuery.views.tags("cssClassGen", function (val) {
			return val.toLowerCase().replace(/ /g, "-");
		});
	}

	if (window["asl_jQuery"] && asl_jQuery.views) {
		asl_jQuery.views.tags(
			"categoryRender",
			function (
				categories,
				lift_recliners_flagship,
				lift_recliners_servicer,
				mobility_scooters_flagship,
				mobility_scooters_servicer,
				power_wheelchairs_flagship,
				power_wheelchairs_servicer,
				beds_flagship,
				beds_servicer
			) {
				// Parse input values and create a flags object
				const flags = {
					"Lift Recliners": {
						flagship: parseInt(lift_recliners_flagship, 10) >= 1,
						servicer: parseInt(lift_recliners_servicer, 10) >= 1,
					},
					"Mobility Scooters": {
						flagship: parseInt(mobility_scooters_flagship, 10) >= 1,
						servicer: parseInt(mobility_scooters_servicer, 10) >= 1,
					},
					"Power Wheelchairs": {
						flagship: parseInt(power_wheelchairs_flagship, 10) >= 1,
						servicer: parseInt(power_wheelchairs_servicer, 10) >= 1,
					},
					"Beds": {
						flagship: parseInt(beds_flagship, 10) >= 1,
						servicer: parseInt(beds_servicer, 10) >= 1,
					},
				};

				// Ensure flagship categories are included
				for (const categoryName in flags) {
					if (
						flags[categoryName].flagship &&
						!categories.some((category) => category.name === categoryName)
					) {
						categories.push({
							name: categoryName,
							flagship: true,
						});
					}
				}

				// Sort categories if needed
				const sortedCategories = sortCategories(categories);

				let renderedHtml = "";

				// Render HTML for each category
				sortedCategories.forEach((category) => {
					const { name } = category;
					const { flagship = false, servicer = false } = flags[name] || {};

					// Generate class names
					let className = `cat-logo-${name.toLowerCase().replace(/ /g, "-").replace(/&/g, "and")}`;
					if (flagship) className += "-flagship";
					if (servicer) className += "-servicer";

					// Generate title text
					let titleText = flagship
						? `This is a Flagship Retailer for ${name}`
						: `This retailer offers ${name}`;
					if (servicer) {
						titleText += flagship ? " and provides service." : ` and provides service for ${name}.`;
					}

					// Generate display name
					const displayName = flagship ? `Flagship ${name}` : name;

					// Render HTML
					renderedHtml += `<li class="cat-logo-wrapper">
						<span title="${titleText}" class="cat-logo ${className}">${displayName}</span>
					</li>`;
				});

				return renderedHtml;
			}
		);
		asl_jQuery.views.tags(
			"serviceTextRender",
			function (
				lift_recliners_servicer,
				mobility_scooters_servicer,
				power_wheelchairs_servicer,
				bed_servicer,
				does_not_provide_service
			) {
				// Parse the input values
				lift_recliners_servicer = parseInt(lift_recliners_servicer, 10);
				mobility_scooters_servicer = parseInt(mobility_scooters_servicer, 10);
				power_wheelchairs_servicer = parseInt(power_wheelchairs_servicer, 10);
				bed_servicer = parseInt(bed_servicer, 10);
				does_not_provide_service = parseInt(does_not_provide_service, 10);

				// Handle "No Service Provided"
				if (does_not_provide_service >= 1) {
					return "<span>No Service Provided</span>";
				}

				// Collect available services
				let services = [];
				if (lift_recliners_servicer >= 1) services.push("Lift Recliners");
				if (mobility_scooters_servicer >= 1) services.push("Mobility Scooters");
				if (power_wheelchairs_servicer >= 1) services.push("Power Wheelchairs");
				if (bed_servicer >= 1) services.push("Beds");

				// Generate the output string
				if (services.length === 0) {
					return "<span>No Service Provided</span>";
				}

				// Join the services with correct grammar
				let serviceText = "";
				if (services.length === 1) {
					serviceText = services[0];
				} else if (services.length === 2) {
					serviceText = services.join(" and ");
				} else {
					serviceText = `${services.slice(0, -1).join(", ")}, and ${services[services.length - 1]}`;
				}

				// Return the formatted HTML
				return `<span>Authorized Service Center for: ${serviceText}</span>`;
			}
		);
	}
};

function sortCategories(categories) {
	const order = [
		"Lift Recliners",
		"Flagship Lift Recliners",
		"Mobility Scooters",
		"Flagship Mobility Scooters",
		"Power Wheelchairs",
		"Beds",
		"Service Centers",
	];

	return categories.sort((a, b) => {
		let nameA = a.name;
		let nameB = b.name;

		// Adjusting names for flagship categories
		if (a.flagship && nameA === "Lift Recliners") {
			nameA = "Flagship Lift Recliners";
		}
		if (b.flagship && nameB === "Lift Recliners") {
			nameB = "Flagship Lift Recliners";
		}
		if (a.scooterflagship && nameA === "Mobility Scooters") {
			nameA = "Flagship Mobility Scooters";
		}
		if (b.scooterflagship && nameB === "Mobility Scooters") {
			nameB = "Flagship Mobility Scooters";
		}

		// Sorting logic
		let indexA = order.indexOf(nameA);
		let indexB = order.indexOf(nameB);

		if (indexA === -1) indexA = order.length;
		if (indexB === -1) indexB = order.length;

		return indexA - indexB;
	});
}
